export const apiUrls = {
  auth: {
    accessToken: "/sso-service/api/v1/auth/access/token",
    logout: "/sso-service/api/v1/auth/logout",
    refreshToken: "/sso-service/api/v1/auth/refresh/token",
  },
  user: {
    profile: "/sso-service/api/v1/user/profile",
    changepassword: `/sso-service/api/v1/user/change/password`,
    forgetPassword: `/sso-service/api/v1/user/forgot/password`,
  },
  dmsService: {
    createRecord: "/dms-service/api/ve1/dms/createRecord",
    getRecords: "/dms-service/api/ve1/dms/getAllRecords",
    getVoucherHeads: "/dms-service/api/ve1/voucher/getAllVoucherHeads",
    getFile: "/dms-service/api/ve1/dms/file",
    approveRequest: "/dms-service/api/ve1/workflow/approve",
    sendBackForRework: "/dms-service/api/ve1/workflow/sendBackForRework",
    getReworkHistory: "/dms-service/api/ve1/workflow/reworkHistory/",
    resubmitAfterRework: "/dms-service/api/ve1/workflow/resubmitAfterRework",
    getAllStores: "/dms-service/api/ve1/store/getAllStores/",
    getAllAreaManager: "/dms-service/api/ve1/store/getAllAm/",
    sendForApproval: "/dms-service/api/ve1/workflow/sendForApproval/",
    getStoreName: "/dms-service/api/ve1/store/getStoreName",
    getNotifications: "/dms-service/api/ve1/dashboard/getNotifications",
    getNotificationCount: "/dms-service/api/ve1/dashboard/getNotificationCount",
    getDashboardData: "/dms-service/api/ve1/dashboard/getDashBoardData",
    getAllRegionalManager: "/dms-service/api/ve1/store/getAllRegionalManagers",
    uploadVoucherFileReport: "/dms-service/api/ve1/voucher/upload/file",
    downloadVouchersSAPUploaderFormat:
      "/dms-service/api/ve1/store/downloadVouchersSAPUploaderFormat",
    downloadConsolidatedVoucherReport:
      "/dms-service/api/ve1/voucher/downloadConsolidatedVoucherReport",
    deleteVoucher: "/dms-service/api/ve1/dms/deleteRecord",
    getDownloadVoucherReport: "/dms-service/api/ve1/voucher/download",
    downloadVoucherStoreLevel:
      "/dms-service/api/ve1/voucher/downloadVouchersInRangeByStore",
    updateVoucherComment: "/dms-service/api/ve1/dms/updateVoucherComment",
    getVoucherDetails: "/dms-service/api/ve1/dms/getRecordById/",
    getSignedUrl: "/dms-service/api/ve1/dms/getSignedfile",
    editVoucherAfterRework: "/dms-service/api/ve1/workflow/editVoucherAfterRework",
    sendAllToNextLevel: "/dms-service/api/ve1/workflow/sendAllToNextLevel",
    canSubmitVoucher: "/dms-service/api/ve1/workflow/canSubmitVoucher",
  },
};
